// ─── LIMBĂ / LANGUAGE (RO implicit, EN opțional) ─────────────────────────────
// Traducerea se face după textul-sursă în română: t("Date personale") întoarce
// versiunea EN dacă limba e engleză și există în dicționar; altfel textul RO
// (deci textele netraduse rămân, elegant, în română — fără să crape nimic).
// Schimbarea limbii reîncarcă aplicația, ca toate ecranele să prindă noua limbă.

const LANG_KEY = "fm_lang";
let _lang = "ro";
try { const s = localStorage.getItem(LANG_KEY); if (s === "en" || s === "ro") _lang = s; } catch (e) {}

export function getLang() { return _lang; }
export function setLang(l) {
  if (l !== "en" && l !== "ro") return;
  try { localStorage.setItem(LANG_KEY, l); } catch (e) {}
  if (l !== _lang) { _lang = l; try { window.location.reload(); } catch (e) {} }
}

// Instrucțiuni de limbă pentru AI (răspunsul AI urmează limba aplicației)
export function aiIn() { return _lang === "en" ? "in English" : "în limba română"; }
export function aiTextLang() { return _lang === "en" ? "Write ALL text in English." : "Toate textele în limba română."; }

// Traducere după cheia = textul românesc
export function t(ro) {
  if (_lang === "ro") return ro;
  return (EN[ro] !== undefined ? EN[ro] : ro);
}
// Variantă pentru texte cu interpolare: tf("Mai ai {n} zile", {n:3})
export function tf(ro, vars = {}) {
  let s = t(ro);
  for (const k in vars) s = s.split(`{${k}}`).join(vars[k]);
  return s;
}

// ─── DICȚIONAR RO → EN ───────────────────────────────────────────────────────
// Se completează progresiv. Ce nu e aici rămâne afișat în română.
const EN = {
  // Navigație / taburi
  "Profil": "Profile",
  "Acasă": "Home",
  "Ciclu": "Cycle",
  "Analize": "Lab results",
  "Tratament": "Treatment",
  "Vaccinuri": "Vaccines",
  "Documente": "Documents",
  "Sumar AI": "AI summary",
  "Familie": "Family",
  "Medici": "Doctors",
  "Setări": "Settings",
  "Feedback": "Feedback",
  "Dosarul meu": "My records",
  "Cercul meu": "My circle",
  "Contul meu": "My account",
  "Meniu": "Menu",
  "Profil nou": "New profile",
  "Deconectare": "Sign out",

  // Autentificare
  "Loghează-te pentru a accesa datele": "Log in to access your data",
  "Creează un cont nou": "Create a new account",
  "Intră în cont": "Log in",
  "Creează cont": "Create account",
  "Am uitat parola": "Forgot password",
  "Email": "Email",
  "Parolă": "Password",
  "Parolă nouă": "New password",
  "Confirmă parola": "Confirm password",
  "Nume complet": "Full name",
  "Data nașterii": "Date of birth",
  "Telefon": "Phone",
  "Se procesează...": "Processing…",
  "Completează email și parolă.": "Enter your email and password.",
  "Email sau parolă incorectă.": "Incorrect email or password.",
  "sau": "or",
  "Continuă cu Google": "Continue with Google",
  "Nu ai cont?": "No account?",
  "Înregistrează-te": "Sign up",
  "Ai cont?": "Have an account?",
  "Loghează-te": "Log in",
  "Vârstă": "Age",
  "Masculin": "Male",
  "Feminin": "Female",
  "Telefon personal": "Personal phone",
  "Nume": "Name",
  "Rudenie": "Relationship",

  // Setări — secțiuni
  "Notificări": "Notifications",
  "Preferințe implicite": "Default preferences",
  "Aspect": "Appearance",
  "Aplicații de sănătate": "Health apps",
  "Securitate": "Security",
  "Suport și informații": "Support & info",
  "Datele mele": "My data",
  "Temă": "Theme",
  "Limbă": "Language",
  "Notificări active": "Notifications on",
  "Alarmă la ora medicamentelor": "Alarm at medication time",
  "Alertă stoc pe terminate": "Low-stock alert",
  "Reminder programări": "Appointment reminders",
  "Notificare menstruație": "Period notification",
  "Autentificare în 2 pași (2FA)": "Two-step verification (2FA)",
  "Deblocare cu biometrie": "Unlock with biometrics",
  "în curând": "coming soon",
  "Descarcă toate datele": "Download all data",
  "Încarcă un backup": "Restore a backup",
  "Contactează suportul": "Contact support",
  "Termeni și condiții": "Terms & conditions",
  "Confidențialitate (GDPR)": "Privacy (GDPR)",
  "Schimbă": "Change",
  "Salvează": "Save",
  "Anulează": "Cancel",

  // Profil (Fișă)
  "Date personale": "Personal details",
  "Raport complet": "Full report",
  "Grupă sanguină": "Blood type",
  "Alergii": "Allergies",
  "ani": "years",
  "Sex": "Sex",
  "Localitate": "Locality",
  "Județ": "County",
  "Țară": "Country",
  "Email cont": "Account email",
  "Persoane de urgență": "Emergency contacts",
  "Grad de rudenie": "Relationship",

  // Analize
  "Ultimele analize": "Latest results",
  "Evoluție": "Trends",
  "Dispozitive": "Devices",
  "Nicio analiză încă.": "No results yet.",
  "Cele mai recente valori": "Most recent values",
  "Interpretare AI": "AI interpretation",
  "Toate analizele": "All results",
  "Niciun dispozitiv conectat încă.": "No device connected yet.",

  // Setări — detalii
  "Permite notificările pe acest dispozitiv": "Allow notifications on this device",
  "Permite": "Allow",
  "Valorile de mai jos sunt pre-completate când adaugi un medicament sau o programare; le poți schimba sau opri individual pentru fiecare.": "The values below are pre-filled when you add a medication or an appointment; you can change or turn them off individually for each.",
  "Alertă stoc înainte cu": "Low-stock alert",
  "Reminder programare înainte cu": "Appointment reminder",
  "Menstruație — anunț înainte cu": "Period — notify before",
  "Menstruație — la ora": "Period — at time",
  "zile": "days",
  "ore": "hours",
  "Sunet alarmă": "Alarm sound",
  "Ore de liniște": "Quiet hours",
  "Conectează": "Connect",
  "Primești un cod pe email la fiecare autentificare.": "You get a code by email at each sign-in.",
  "Descarcă": "Download",
  "Încarcă": "Upload",

  // Familie
  "Membrii familiei": "Family members",
  "Condiții medicale": "Medical conditions",
  "Niciun membru adăugat.": "No members added.",

  // Vaccinuri
  "Nume vaccin": "Vaccine name",
  "Data administrării": "Date given",
  "Doza (opțional)": "Dose (optional)",
  "Următoarea doză (opțional)": "Next dose (optional)",
  "Notițe (opțional)": "Notes (optional)",

  // Documente
  "Nume document": "Document name",
  "Alege categoria": "Choose category",
  "Imagistică": "Imaging",
  "Rețetă": "Prescription",
  "Altele": "Other",
  "✎ Redenumește": "✎ Rename",
  "→ Mută": "→ Move",
  "⎋ Deconectare": "⎋ Sign out",

  // Sumar AI
  "Perioadă analiză": "Analysis period",
  "De la": "From",
  "Până la": "To",
  "Starea actuală de sănătate": "Current health status",
  "Rezumat": "Summary",
  "Observații": "Observations",
  "Progres general": "Overall progress",

  // Tratament & medici
  "Nimic programat pe astăzi": "Nothing scheduled for today",
  "Sărit": "Skipped",
  "Doză": "Dose",
  "Plan de tratament activ": "Active treatment plan",
  "Diagnostic": "Diagnosis",
  "Data diagnosticului": "Diagnosis date",
  "Specializare": "Specialty",
  "Nume medic": "Doctor name",
  "Spital / Clinică": "Hospital / Clinic",
  "Parafă": "Stamp code",
  "Adresă": "Address",
  "Notițe": "Notes",
  "Selectează ce date partajezi:": "Choose what data you share:",
  "Salvează programare": "Save appointment",
  "Notițe vizită": "Visit notes",
  "Reminder": "Reminder",
  "Medic": "Doctor",

  // Ciclu
  "Loghează prima menstruație": "Log your first period",
  "Ziua ciclului": "Cycle day",
  "Următoarea": "Next",
  "Perioada": "Period",
  "Ovulație": "Ovulation",
  "Menstruație": "Period",
  "Estimat": "Estimated",
  "Fertilă + Ovulație": "Fertile + Ovulation",
  "Predicție": "Prediction",
  "Lungimea menstruației": "Period length",
  "Lungimea ciclului menstrual": "Cycle length",
  "Lungimea fazei luteale": "Luteal phase length",
  "Salvează simptome": "Save symptoms",
  "Protejat": "Protected",
  "Neprotejat": "Unprotected",
  "Cu orgasm": "With orgasm",
  "Fără orgasm": "Without orgasm",
  "Salvează contactul intim": "Save intimacy",
  "Salvează notița": "Save note",

  // Titluri modale
  "Fișier existent": "File already exists",
  "⚠ Șterge contul definitiv": "⚠ Delete account permanently",
  "Redenumește document": "Rename document",
  "Mută document": "Move document",
  "Adaugă doză medicament": "Add medication dose",
  "Diagnostic nou": "New diagnosis",
  "Interpretare AI a analizelor": "AI interpretation of results",
  "Compară studii imagistice": "Compare imaging studies",
  "Adaugă analiză manual": "Add result manually",
  "Editează medicament": "Edit medication",
  "Medicament nou": "New medication",
  "Programare nouă": "New appointment",
  "Export Plan Tratament": "Export treatment plan",
  "Raport medical complet": "Full medical report",
  "Adaugă notiță": "Add note",
  "Simptome": "Symptoms",
  "Editează simptom": "Edit symptom",
  // ── Jurnal: selector perioadă + explicație încredere ──
  "Perioadă analizată": "Analyzed period",
  "An": "Year",
  "Interval": "Range",
  "Ultimele 30 zile": "Last 30 days",
  "Analizează": "Analyze",
  "Alege un interval valid (de la / până la).": "Choose a valid range (from / to).",
  "Nu există mese înregistrate în perioada aleasă.": "No meals logged in the chosen period.",
  "Încrederea = cât de sigur e AI-ul că alimentul e cauza, nu o coincidență:": "Confidence = how sure the AI is that the food is the cause, not a coincidence:",
  "ridicată": "high",
  "= pattern repetat constant;": "= consistently repeated pattern;",
  "medie": "medium",
  "= apare des dar nu mereu;": "= appears often but not always;",
  "scăzută": "low",
  "= o ipoteză din puține date.": "= a hypothesis from little data.",
  "Menstruația e estimată azi.": "Your period is expected today.",
  "Jurnalul nu s-a putut salva în baza de date.\n\nMotiv: ": "The journal could not be saved to the database.\n\nReason: ",
  "\n\nTabelul gut_data pare să lipsească sau API-ul nu l-a preluat încă. Verifică în Supabase că SQL-ul din docs/gut-journal.sql a rulat, apoi Settings → API → „Reload schema”.": "\n\nThe gut_data table seems to be missing or the API hasn't picked it up yet. Check in Supabase that the SQL from docs/gut-journal.sql ran, then Settings → API → \"Reload schema\".",
  "Editezi o intrare existentă": "Editing an existing entry",
  // ── Jurnal digestiv ──
  "Jurnal zilnic": "Daily journal",
  "Analiză AI": "AI analysis",
  "↩ Sari la azi": "↩ Jump to today",
  "Mâncare / Băutură": "Food / Drink",
  "Scaun": "Stool",
  "Simptom": "Symptom",
  "Ce ai mâncat / băut?": "What did you eat / drink?",
  "ex: iaurt cu musli și miere, cafea cu lapte": "e.g. yogurt with muesli and honey, coffee with milk",
  "Consistență (scala Bristol)": "Consistency (Bristol scale)",
  "Tip 1 — bile tari, separate (constipație severă)": "Type 1 — hard, separate lumps (severe constipation)",
  "Tip 2 — formă de cârnat, cocoloșat (constipație)": "Type 2 — sausage-shaped, lumpy (constipation)",
  "Tip 3 — cârnat cu crăpături (normal)": "Type 3 — sausage with cracks (normal)",
  "Tip 4 — neted și moale (ideal)": "Type 4 — smooth and soft (ideal)",
  "Tip 5 — bucăți moi, margini clare (tendință spre diaree)": "Type 5 — soft blobs, clear edges (leaning to diarrhea)",
  "Tip 6 — bucăți pufoase, margini zdrențuite (diaree ușoară)": "Type 6 — fluffy pieces, ragged edges (mild diarrhea)",
  "Tip 7 — apos, fără bucăți solide (diaree)": "Type 7 — watery, no solid pieces (diarrhea)",
  "Notă (opțional)": "Note (optional)",
  "ex: urgență, mucus, durere": "e.g. urgency, mucus, pain",
  "Nimic înregistrat în această zi. Adaugă ce ai mâncat, băut sau cum a fost scaunul.": "Nothing logged this day. Add what you ate, drank, or how your stool was.",
  "din Tratament → Simptome": "from Treatment → Symptoms",
  "Ștergi această intrare?": "Delete this entry?",
  "Analiză generată de AI pe baza jurnalului — orientativă, nu diagnostic. Corelațiile devin utile după cel puțin 1-2 săptămâni de date.": "AI-generated analysis based on your journal — for guidance, not a diagnosis. Correlations become useful after at least 1-2 weeks of data.",
  "intrări în jurnal": "journal entries",
  "simptome înregistrate": "symptoms logged",
  "Analizez...": "Analyzing...",
  "Analizează ultimele 30 zile": "Analyze last 30 days",
  "Caut corelații între alimente, simptome și scaun...": "Looking for correlations between foods, symptoms and stool...",
  "Analiza a eșuat. Încearcă din nou.": "Analysis failed. Try again.",
  "Completează jurnalul câteva zile, apoi apasă „Analizează” — AI-ul caută ce alimente îți declanșează balonarea sau alte simptome.": "Fill in the journal for a few days, then press \"Analyze\" — the AI looks for which foods trigger your bloating or other symptoms.",
  "🚨 Alimente suspecte": "🚨 Suspect foods",
  "🔗 Corelații observate": "🔗 Observed correlations",
  "🚻 Evoluția scaunului": "🚻 Stool pattern",
  "✓ Bine tolerate": "✓ Well tolerated",
  "încredere ridicată": "high confidence",
  "încredere medie": "medium confidence",
  "încredere scăzută": "low confidence",
  // ── EN batch: auth, exporturi, notificări, dialoguri ──
  "1 zi rămasă până la menstruație.": "1 day left until your period.",
  "Această invitație e pentru": "This invitation is for",
  "Adaugă cel puțin o persoană de contact în caz de urgență.": "Add at least one emergency contact.",
  "Adaugă cel puțin o persoană de urgență (nume + telefon).": "Add at least one emergency contact (name + phone).",
  "Alege o parolă nouă pentru contul tău": "Choose a new password for your account",
  "Analizele de laborator (cu interval de referință)": "Lab tests (with reference ranges)",
  "Arată": "Show",
  "Ascunde": "Hide",
  "Caută județul...": "Search county...",
  "Caută localitatea...": "Search locality...",
  "Codul a expirat. Apasă Retrimite codul.": "The code has expired. Press Resend code.",
  "Completează data nașterii.": "Enter your date of birth.",
  "Completează județul.": "Enter your county.",
  "Completează localitatea.": "Enter your locality.",
  "Completează numele.": "Enter your name.",
  "Completează numărul de telefon.": "Enter your phone number.",
  "Completează țara.": "Enter your country.",
  "Confirmă": "Confirm",
  "Continuă": "Continue",
  "Consultații și programări": "Consultations & appointments",
  "Consultațiile și programările": "Consultations and appointments",
  "Cont creat! Verifică emailul și confirmă contul, apoi loghează-te.": "Account created! Check your email and confirm the account, then log in.",
  "Conținut export:": "Export contents:",
  "Descarcă Excel": "Download Excel",
  "Doze administrate în perioadă": "Doses taken in the period",
  "Email deja înregistrat. Loghează-te.": "Email already registered. Log in.",
  "Eroare de rețea.": "Network error.",
  "Ești logat cu": "You are logged in as",
  "Fișierul": "The file",
  "Generează PDF": "Generate PDF",
  "Generează raportul": "Generate report",
  "Grupă:": "Blood type:",
  "Indicație": "Indication",
  "Intrările confirmate rămân în istoric.": "Confirmed entries remain in the history.",
  "Invitație acceptată! Ai acces ca": "Invitation accepted! You have access as",
  "Județ *": "County *",
  "Localitate *": "Locality *",
  "Limita gratuită AI atinsă (~20 cereri/minut, partajate de toată aplicația). Încearcă din nou peste": "Free AI limit reached (~20 requests/minute, shared across the app). Try again in",
  "Limita gratuită AI încă activă. Mai așteaptă": "Free AI limit still active. Wait another",
  "Log-uri copiate! Le poți lipi oriunde (ex. într-un mesaj).": "Logs copied! You can paste them anywhere (e.g. in a message).",
  "Neconfirmat (zi trecută)": "Unconfirmed (past day)",
  "Nicio analiză în perioada selectată.": "No lab tests in the selected period.",
  "Nicio consultație sau programare în perioada selectată.": "No consultations or appointments in the selected period.",
  "Notiță goală": "Empty note",
  "Notă": "Note",
  "Nu am putut citi data din document.\nCe dată au aceste rezultate? (format ZZ.LL.AAAA)": "Could not read the date from the document.\nWhat date are these results from? (DD.MM.YYYY format)",
  "Nu am putut șterge": "Could not delete",
  "Nu am putut șterge doctorul din baza de date. Verifică conexiunea și încearcă din nou.": "Could not delete the doctor from the database. Check your connection and try again.",
  "Nu am putut șterge extragerea din baza de date. Încearcă din nou.": "Could not delete the extraction from the database. Try again.",
  "Nu am putut șterge membrul din baza de date. Încearcă din nou.": "Could not delete the member from the database. Try again.",
  "Nu am putut șterge măsurătoarea din baza de date. Încearcă din nou.": "Could not delete the measurement from the database. Try again.",
  "Nu am putut șterge simptomul din baza de date. Încearcă din nou.": "Could not delete the symptom from the database. Try again.",
  "Nu am putut șterge vaccinul din baza de date. Încearcă din nou.": "Could not delete the vaccine from the database. Try again.",
  "Nu există un cod activ. Apasă Retrimite codul.": "There is no active code. Press Resend code.",
  "Numărul de telefon trebuie să aibă 10 cifre.": "The phone number must have 10 digits.",
  "Parola a fost schimbată cu succes.": "Password changed successfully.",
  "Plan tratament activ — medicament, administrare, indicație": "Active treatment plan — medication, dosing, indication",
  "Pozele se micșorează automat; pentru un PDF prea mare, încearcă să-l comprimi sau să-l împarți în fișiere mai mici.": "Photos are resized automatically; for a PDF that is too large, try compressing it or splitting it into smaller files.",
  "Prea multe cereri către AI. Încearcă din nou peste un minut.": "Too many AI requests. Try again in a minute.",
  "Programare medicală": "Medical appointment",
  "Raport generat automat din aplicația Fișă Medicală. Nu înlocuiește un document medical oficial.": "Report generated automatically by the Fișă Medicală app. It does not replace an official medical document.",
  "Restaurează": "Restore",
  "Salut! Te invit să accesezi profilul medical:": "Hi! I'm inviting you to access this medical profile:",
  "Salvează și începe": "Save and start",
  "Schimbă parola": "Change password",
  "Scrie întâi adresa de email, apoi apasă „Am uitat parola”.": "Enter your email address first, then press \"Forgot password\".",
  "Se salvează...": "Saving...",
  "Se verifică…": "Verifying…",
  "Se șterge...": "Deleting...",
  "Selectează sexul.": "Select your sex.",
  "Simptome și notițe": "Symptoms & notes",
  "Telefonul persoanei de urgență trebuie să aibă 10 cifre.": "The emergency contact's phone must have 10 digits.",
  "Tensiune arterială": "Blood pressure",
  "Toate datele acestui profil vor fi pierdute. Contul tău rămâne.": "All data in this profile will be lost. Your account remains.",
  "Trebuie să accepți Termenii și Politica de confidențialitate pentru a crea un cont.": "You must accept the Terms and the Privacy Policy to create an account.",
  "Un singur PDF, util de dus la consult, cu tot ce s-a întâmplat în perioada aleasă:": "A single PDF, handy to bring to a consultation, with everything that happened in the chosen period:",
  "Valori medicale (tensiune, glicemie, greutate) dacă există": "Medical values (blood pressure, blood sugar, weight) if available",
  "Valori măsurate": "Measured values",
  "Valori medicale": "Medical values",
  "Verificare eșuată.": "Verification failed.",
  "Verifică emailul și confirmă contul înainte de a te loga.": "Check your email and confirm the account before logging in.",
  "Vrei să îl/o adaugi și tu ca": "Do you also want to add them as",
  "a fost adăugat de": "was added by",
  "a fost deja încărcat pe": "was already uploaded on",
  "altă unitate": "other unit",
  "are deja cont și a primit acces automat.": "already has an account and was granted access automatically.",
  "are deja rol de îngrijitor pentru acest profil. O persoană nu poate fi și medic și îngrijitor simultan. Revocă întâi celălalt rol.": "already has a caregiver role for this profile. A person cannot be both doctor and caregiver at the same time. Revoke the other role first.",
  "are intrări confirmate mai vechi care nu pot fi păstrate. Dacă îl ștergi, acele intrări vor dispărea din istoric. Continui?": "has older confirmed entries that cannot be kept. If you delete it, those entries will disappear from the history. Continue?",
  "din baza de date. Verifică conexiunea și încearcă din nou.": "from the database. Check your connection and try again.",
  "doză": "dose",
  "emailul tău": "your email",
  "necunoscută": "unknown",
  "o dată la": "once every",
  "o dată pe zi": "once a day",
  "de 2 ori pe zi": "twice a day",
  "de 3 ori pe zi": "3 times a day",
  "de": "",
  "ori pe zi": "times a day",
  "la ora": "at",
  "săptămânal:": "weekly:",
  "ciclu": "cycle",
  "zilnic": "daily",
  "pentru acest profil. O persoană nu poate fi și îngrijitor și medic simultan. Revocă întâi celălalt rol.": "for this profile. A person cannot be both caregiver and doctor at the same time. Revoke the other role first.",
  "are deja rol de": "already has the role of",
  "să conțină cel puțin o cifră": "contain at least one digit",
  "să conțină cel puțin o majusculă": "contain at least one uppercase letter",
  "să conțină cel puțin un caracter special (ex: ! @ # ?)": "contain at least one special character (e.g. ! @ # ?)",
  "să fie compusă din cel puțin 6 caractere": "be at least 6 characters long",
  "Din motive de securitate parola trebuie:": "For security reasons the password must:",
  "minim 6 caractere": "at least 6 characters",
  "o literă mare": "an uppercase letter",
  "o cifră": "a digit",
  "un semn special (! @ # ?)": "a special character (! @ # ?)",
  "zile rămase până la menstruație.": "days left until your period.",
  "Îngrijitor": "Caregiver",
  "îngrijitor": "caregiver",
  "medic": "doctor",
  "Medicul": "The doctor",
  "îți mai ajunge pentru": "you have enough left for",
  "Șterge definitiv": "Delete permanently",
  "Șterge din listă": "Remove from list",
  "Ștergi": "Delete",
  "Ștergi profilul": "Delete profile",
  "Ștergi toate log-urile?": "Delete all logs?",
  "și": "and",
  "Ți-am trimis un cod pe email.": "We've sent you a code by email.",
  "Ți-am trimis un email cu instrucțiuni de resetare a parolei. Verifică inboxul.": "We've sent you an email with password reset instructions. Check your inbox.",
  "⚠ Numărul trebuie să aibă 10 cifre": "⚠ The number must have 10 digits",
  "E ora": "It's",
  "Stoc pe terminate": "Stock running low",
  "Programare": "Appointment",
  "secunde": "seconds",
  "un minut": "a minute",
  "selectat": "selected",
  "este prea mare": "is too large",
  "Limita este": "The limit is",
  "acest profil": "this profile",
  "Acces reactivat pentru": "Access reactivated for",
  "Lun": "Mon",
  "Mar": "Tue",
  "Mie": "Wed",
  "Joi": "Thu",
  "Vin": "Fri",
  "Sâm": "Sat",
  "Dum": "Sun",
  "Administrare": "Dosing",
  "Doze": "Doses",
  "Tip": "Type",
  "Plan Tratament": "Treatment Plan",
  "Plan de Tratament": "Treatment Plan",
  "Plan Tratament Activ": "Active Treatment Plan",
  "Jurnal": "Journal",
  "Pacient:": "Patient:",
  "Planificat": "Planned",
  "Confirmate": "Confirmed",
  "U.M.": "Unit",
  "Interval ref.": "Ref. range",
  "Specialitate/Titlu": "Specialty/Title",
  "Medic / Unitate": "Doctor / Facility",
  "Simptome raportate": "Reported symptoms",
  "Niciun tratament activ.": "No active treatment.",
  "Perioada:": "Period:",
  "Luna": "Month",
  "Format": "Format",
  "Raport": "Report",
  "Jurnal — medicamentele administrate": "Journal — medications taken",
  "Planul de tratament activ + dozele administrate": "Active treatment plan + doses taken",
  "Simptomele raportate": "Reported symptoms",
  "Graficele de tensiune, glicemie, greutate": "Blood pressure, blood sugar and weight charts",
  "Analize de laborator": "Lab tests",
  "Soț/Soție": "Spouse",
  "Rudă": "Relative",
  "Soacră": "Mother-in-law",
  "Socru": "Father-in-law",
  "Nu am putut trimite codul.": "Could not send the code.",
  "Introdu codul din 6 cifre.": "Enter the 6-digit code.",
  // ── Vaccinuri ──
  "Altul (scrie manual)": "Other (type manually)",
  "Calendar Național (copilărie)": "National schedule (childhood)",
  "Recomandate / opționale": "Recommended / optional",
  "Călătorie": "Travel",
  "Hepatită B (la naștere)": "Hepatitis B (at birth)",
  "BCG / tuberculoză (la naștere, 4-7 zile)": "BCG / tuberculosis (at birth, 4-7 days)",
  "Hexavalent DTPa-VPI-Hib-HepB (2, 4, 11 luni)": "Hexavalent DTaP-IPV-Hib-HepB (2, 4, 11 months)",
  "Pneumococic PCV (2, 4, 11 luni)": "Pneumococcal PCV (2, 4, 11 months)",
  "ROR rujeolă-rubeolă-oreion (1 an, 5 ani)": "MMR measles-rubella-mumps (1 year, 5 years)",
  "DTPa rapel (6 ani)": "DTaP booster (6 years)",
  "dT rapel (14 ani, apoi la 10 ani)": "dT booster (14 years, then every 10 years)",
  "VPI poliomielită (6 ani)": "IPV polio (6 years)",
  "HPV papilomavirus (11-14 ani, fete și băieți)": "HPV papillomavirus (11-14 years, girls and boys)",
  "HPV (papilomavirus)": "HPV (papillomavirus)",
  "Gripal (antigripal)": "Flu (influenza)",
  "Varicelă": "Chickenpox",
  "Meningococic": "Meningococcal",
  "Hepatită A": "Hepatitis A",
  "Encefalită de căpușă (TBE)": "Tick-borne encephalitis (TBE)",
  "Febră galbenă": "Yellow fever",
  "Febră tifoidă": "Typhoid fever",
  "Holeră": "Cholera",
  "Rabie": "Rabies",
  "Encefalită japoneză": "Japanese encephalitis",
  "Doza:": "Dose:",
  "Următoarea doză:": "Next dose:",
  "\n\nÎncearcă din nou peste câteva secunde.": "\n\nTry again in a few seconds.",
  "Adaugă membru familie": "Add family member",
  "Editează medic": "Edit doctor",
  "Editează valori": "Edit values",
  "Editează:": "Edit:",
  "Generez sumar AI...": "Generating AI summary...",
  "Generez sumar anual AI...": "Generating annual AI summary...",
  "Generez sumar general AI...": "Generating general AI summary...",
  "necunoscut": "unknown",
  "Înregistrare valori": "Log values",
  // ── EN batch: tabs (Analize/Tratament/Documente/Sumar/Family/Settings) ──
  "Diagnostice": "Diagnoses",
  "Niciun diagnostic adăugat.": "No diagnoses added.",
  "Medic nou": "New doctor",
  "Spital/Clinică": "Hospital/Clinic",
  "Partajare activă": "Sharing active",
  "Niciun medic adăugat.": "No doctors added.",
  "ex: Ana Ionescu": "e.g. Jane Doe",
  "Raport PDF cu tratament, analize, consultații și valori pe o perioadă": "PDF report with treatment, lab tests, consultations and values over a period",
  "Anulează fără salvare": "Cancel without saving",
  "Fișă personală": "Personal record",
  "Interpretare generată de AI, orientativă. Nu înlocuiește consultul și interpretarea unui medic.": "AI-generated interpretation, for guidance only. It does not replace a doctor's consultation and interpretation.",
  "Se analizează valorile...": "Analyzing values...",
  "Interpretarea a eșuat. Încearcă din nou.": "Interpretation failed. Try again.",
  "Se compară...": "Comparing...",
  "Compară": "Compare",
  "studii cu AI": "studies with AI",
  "Se compară studiile imagistice...": "Comparing imaging studies...",
  "Comparație salvată": "Saved comparison",
  "eroare necunoscută": "unknown error",
  "Status calculat:": "Calculated status:",
  "Normal": "Normal",
  "↑ Crescut": "↑ High",
  "↓ Scăzut": "↓ Low",
  "ca analiză nouă": "as a new test",
  "Ștergi analiza personalizată": "Delete the custom test",
  "înregistrări": "records",
  "Editează valoarea": "Edit value",
  "Șterge această valoare": "Delete this value",
  "Gestionează valorile": "Manage values",
  "din document": "from document",
  "manual": "manual",
  "Listă": "List",
  "Categorii": "Categories",
  "Grafic": "Chart",
  "Valori": "Values",
  "Încarcă un document în tab-ul": "Upload a document in the",
  "și valorile se extrag automat cu AI, sau adaugă o analiză manual aici.": "tab and the values are extracted automatically with AI, or add a test manually here.",
  "Interval referință": "Reference range",
  "Generat:": "Generated:",
  "Semne vitale": "Vital signs",
  "Biochimie": "Biochemistry",
  "Enzime": "Enzymes",
  "Lipide": "Lipids",
  "Hormoni": "Hormones",
  "Minerale": "Minerals",
  "Coagulare": "Coagulation",
  "Urină": "Urine",
  "Imunologie": "Immunology",
  "Personalizate": "Custom",
  "Tensiune": "Blood pressure",
  "Greutate": "Weight",
  "Saturație O₂": "O₂ saturation",
  "Puls": "Pulse",
  "Temperatură": "Temperature",
  "Sistolică": "Systolic",
  "Diastolică": "Diastolic",
  "Săptămână": "Week",
  "Plan tratament": "Treatment plan",
  "Astăzi": "Today",
  "Rezolvat": "Resolved",
  "Confirmat": "Confirmed",
  "Deschide luna": "Open month",
  "Închide luna": "Close month",
  "Medicament șters": "Deleted medication",
  "Ștergi această doză?": "Delete this dose?",
  "Adaugă doză": "Add dose",
  "din": "from",
  "Stoc suficient până la": "Stock lasts until",
  "Stoc:": "Stock:",
  "Se administrează doar la nevoie, fără orar fix.": "Taken only as needed, with no fixed schedule.",
  "zile activ": "days on",
  "zile pauză": "days off",
  "se repetă": "repeats",
  "Salvează modificările": "Save changes",
  "Adaugă medicament": "Add medication",
  "Șterge medicament": "Delete medication",
  "Adăugare manuală — valorile din documente se extrag automat la upload.": "Manual entry — values from documents are extracted automatically on upload.",
  "Zilnic": "Daily",
  "Interval ore": "Hour interval",
  "Interval zile": "Day interval",
  "Interval luni": "Month interval",
  "Zile săptămână": "Weekdays",
  "Ciclic": "Cyclic",
  "Se trimite pe": "Sent to",
  "Adaugă email pentru a activa": "Add an email to enable",
  "Adresa": "The address",
  "are deja rol de îngrijitor pentru acest profil. Nu poate fi și medic. Revocă întâi rolul de îngrijitor.": "already has a caregiver role for this profile. They cannot also be a doctor. Revoke the caregiver role first.",
  "are deja rol de medic pentru acest profil. Nu poate fi și îngrijitor. Revocă întâi rolul de medic.": "already has a doctor role for this profile. They cannot also be a caregiver. Revoke the doctor role first.",
  "Culoare badge — marcaj pe intrările introduse de": "Badge color — marker on entries added by",
  "această persoană": "this person",
  "ex: 6.5": "e.g. 6.5",
  "ex: 117": "e.g. 117",
  "(actual)": "(current)",
  "Extras": "Extracted",
  "Șterge extragerea": "Delete extraction",
  "Opțiuni": "Options",
  "extrase": "extracted",
  "Niciun document încărcat.": "No documents uploaded.",
  "Niciun document în această categorie.": "No documents in this category.",
  "Săptămâna curentă": "Current week",
  "Ultimele 4 săptămâni": "Last 4 weeks",
  "Perioadă personalizată": "Custom period",
  "Comparat cu:": "Compared with:",
  "Generează": "Generate",
  "Generez...": "Generating...",
  "Selectează perioada și apasă „Generează”.": "Select the period and press \"Generate\".",
  "Sărite:": "Missed:",
  "Sumar": "Summary",
  "săptămânal": "weekly",
  "General": "General",
  "Săptămânal": "Weekly",
  "Anual": "Annual",
  "Actualizează": "Update",
  "Sumar general de sănătate": "General health summary",
  "Sumar anual": "Annual summary",
  "Anul": "Year",
  "Apasă „Generează” pentru sumarul anului": "Press \"Generate\" for the summary of year",
  "Respectarea tratamentului": "Treatment adherence",
  "Schimbări medicație": "Medication changes",
  "Tendințe valori": "Value trends",
  "Evoluție diagnostice": "Diagnosis evolution",
  "Avertismente": "Warnings",
  "Îmbunătățiri": "Improvements",
  "Îngrijorări": "Concerns",
  "Evenimente cheie": "Key events",
  "Link de acces trimis la": "Access link sent to",
  "Conectează o aplicație ca să imporți automat valori (puls, pași, somn, greutate, saturație, tensiune). Datele apar în": "Connect an app to import values automatically (pulse, steps, sleep, weight, oxygen saturation, blood pressure). The data appears in",
  "Se salvează…": "Saving…",
  "Șterge profilul": "Delete profile",
  "Șterge tot contul": "Delete entire account",
  "Nu am putut salva setarea.": "Could not save the setting.",
  "Introdu parola actuală.": "Enter your current password.",
  "Parolele noi nu coincid.": "The new passwords don't match.",
  "Parola actuală este greșită.": "The current password is incorrect.",
  "Parola a fost schimbată.": "Password changed.",
  "Nu am putut schimba parola. Încearcă din nou.": "Could not change the password. Try again.",
  "Notificările sunt active ✓": "Notifications are active ✓",
  "Luminos": "Light",
  "Întunecat": "Dark",
  "Dispozitiv": "Device",
  "Notiță": "Note",
  "Fișă Medicală este un instrument personal de organizare a informațiilor medicale. Nu oferă sfaturi, diagnostice sau tratamente medicale și nu înlocuiește consultul unui medic. Ești responsabil(ă) pentru corectitudinea datelor introduse. Rezumatele și interpretările generate de AI sunt orientative și pot conține erori — verifică-le întotdeauna cu un medic. Prin folosirea aplicației accepți acești termeni.": "Fișă Medicală is a personal tool for organizing medical information. It does not provide medical advice, diagnoses or treatments and does not replace a doctor's consultation. You are responsible for the accuracy of the data you enter. AI-generated summaries and interpretations are for guidance only and may contain errors — always check them with a doctor. By using the app you accept these terms.",
  "Datele tale medicale sunt stocate securizat și sunt vizibile doar ție și persoanelor cărora le acorzi explicit acces (îngrijitori, medici). Nu vindem și nu partajăm datele cu terți. Poți exporta sau șterge oricând toate datele din contul tău, inclusiv ștergerea definitivă a contului din această secțiune. Documentele încărcate sunt accesibile prin linkuri temporare, care expiră automat. Pentru orice solicitare legată de datele tale personale, folosește butonul de contact al suportului.": "Your medical data is stored securely and is visible only to you and the people you explicitly grant access to (caregivers, doctors). We do not sell or share your data with third parties. You can export or delete all data in your account at any time, including permanently deleting the account from this section. Uploaded documents are accessible through temporary links that expire automatically. For any request regarding your personal data, use the support contact button.",
  // ── Ciclu menstrual ──
  "Perioadă fertilă": "Fertile window",
  "Faza menstruală": "Menstrual phase",
  "Faza foliculară": "Follicular phase",
  "Faza luteală": "Luteal phase",
  "Ovulația": "Ovulation",
  "Mare – Șanse de a rămâne însărcinată": "High – Chance of conceiving",
  "Mediu – Șanse de a rămâne însărcinată": "Medium – Chance of conceiving",
  "Redus – Șanse de a rămâne însărcinată": "Low – Chance of conceiving",
  "Ziua": "Day",
  "zi rămasă": "day left",
  "zile rămase": "days left",
  "zi": "day",
  "întârziere": "late",
  "Editare": "Edit",
  "Începutul menstruației": "Start of period",
  "Atingeți data pentru a ajusta menstruația": "Tap a date to adjust your period",
  "Contact intim": "Intimate activity",
  "Predicție inteligentă": "Smart prediction",
  "Bazată pe datele introduse de tine. Acuratețea se îmbunătățește cu cât introduci mai multe date.": "Based on the data you enter. Accuracy improves as you add more data.",
  "Cicluri neregulate": "Irregular cycles",
  "Când este pornit, ciclurile neregulate vor fi ignorate, făcând predicțiile mult mai acurate.": "When on, irregular cycles are ignored, making predictions much more accurate.",
  "Intervalul dintre ovulație și menstruație. Standard 14 zile pentru majoritatea persoanelor. Folosită pentru a estima ovulația și fereastra fertilă. Modific-o doar dacă știi valoarea ta exactă (de la medic sau monitorizare).": "The interval between ovulation and menstruation. Standard is 14 days for most people. Used to estimate ovulation and the fertile window. Change it only if you know your exact value (from a doctor or tracking).",
  "(calculat automat)": "(auto-calculated)",
  "(setat manual)": "(set manually)",
  "ziua": "day",
  "zilele": "days",
  "✕ Închide": "✕ Close",
  "➕ Adaugă": "➕ Add",
  "Șterge contactul intim": "Delete intimate activity",
  "1 lună": "1 month",
  "3 luni": "3 months",
  "6 luni": "6 months",
  "12 luni": "12 months",
  "Total": "Total",
  "în medie zilnic": "on average daily",
  "odată la": "once every",
  "Șterge notița": "Delete note",
  "Editează menstruația": "Edit period",
  "Zile de menstruație": "Period days",
  "💕 De câte ori": "💕 How many times",
  "🛡️ Protejat": "🛡️ Protected",
  "🔥 Neprotejat": "🔥 Unprotected",
  "🎉 Cu orgasm": "🎉 With orgasm",
  "🔄 Frecvența": "🔄 Frequency",
  // luni scurte (MSHORT) + zile scurte (WDAYS)
  "Ian": "Jan",
  "Iun": "Jun",
  "Iul": "Jul",
  "Lu": "Mo",
  "Ma": "Tu",
  "Mi": "We",
  "Jo": "Th",
  "Vi": "Fr",
  "Sâ": "Sa",
  "Du": "Su",
  "Selectează simptome": "Select symptoms",
  "selectate": "selected",
  "Șterge intrarea": "Delete entry",
  // ── Simptome (nume) ──
  "Aciditate gastrică": "Stomach acidity",
  "Amețeală": "Dizziness",
  "Amorțeală în membre": "Numbness in limbs",
  "Apnee de somn": "Sleep apnea",
  "Balonare": "Bloating",
  "Cârcei musculari": "Muscle cramps",
  "Cojirea pielii": "Skin peeling",
  "Constipație": "Constipation",
  "Coșmaruri frecvente": "Frequent nightmares",
  "Crampe stomacale": "Stomach cramps",
  "Depresie": "Depression",
  "Dezorientare spațială": "Spatial disorientation",
  "Diaree": "Diarrhea",
  "Dificultate în respirație": "Difficulty breathing",
  "Dificultate la înghițire": "Difficulty swallowing",
  "Dificultate la mers": "Difficulty walking",
  "Dificultăți de concentrare": "Difficulty concentrating",
  "Durere abdominală": "Abdominal pain",
  "Durere de cap": "Headache",
  "Durere de ureche": "Earache",
  "Durere în gât": "Sore throat",
  "Durere în piept": "Chest pain",
  "Durere lombară": "Lower back pain",
  "Dureri articulare": "Joint pain",
  "Dureri de ochi": "Eye pain",
  "Dureri de spate": "Back pain",
  "Dureri musculare": "Muscle pain",
  "Erupție cutanată": "Skin rash",
  "Febră": "Fever",
  "Foame excesivă": "Excessive hunger",
  "Frisoane": "Chills",
  "Furnicături în mâini sau picioare": "Tingling in hands or feet",
  "Ganglioni limfatici umflați": "Swollen lymph nodes",
  "Greață": "Nausea",
  "Gură uscată": "Dry mouth",
  "Gust amarnic sau metalic": "Bitter or metallic taste",
  "Incontinență urinară": "Urinary incontinence",
  "Insomnie": "Insomnia",
  "Iritabilitate crescută": "Increased irritability",
  "Îngălbenirea ochilor": "Yellowing of the eyes",
  "Îngălbenirea pielii": "Yellowing of the skin",
  "Lăcrimare excesivă": "Excessive tearing",
  "Lipsă de coordonare": "Lack of coordination",
  "Luare bruscă în greutate": "Sudden weight gain",
  "Mâncărime de piele": "Itchy skin",
  "Nas înfundat": "Stuffy nose",
  "Oboseală accentuată": "Severe fatigue",
  "Ochi uscați": "Dry eyes",
  "Paloare accentuată": "Marked paleness",
  "Palpitații": "Palpitations",
  "Pierderea echilibrului": "Loss of balance",
  "Pierderea gustului": "Loss of taste",
  "Pierderea mirosului": "Loss of smell",
  "Pierderea poftei de mâncare": "Loss of appetite",
  "Pierderea vocii": "Loss of voice",
  "Piele uscată": "Dry skin",
  "Plâns facil sau labilitate emoțională": "Easy crying or emotional lability",
  "Puls accelerat": "Rapid pulse",
  "Puls foarte scăzut": "Very low pulse",
  "Regurgitare": "Regurgitation",
  "Respirație rapidă": "Rapid breathing",
  "Respirație șuierătoare": "Wheezing",
  "Rigiditate articulară": "Joint stiffness",
  "Răgușeală": "Hoarseness",
  "Roșeață localizată": "Localized redness",
  "Sângerare nazală": "Nosebleed",
  "Scăderea auzului": "Hearing loss",
  "Scădere bruscă în greutate": "Sudden weight loss",
  "Senzație de căldură excesivă": "Feeling of excessive heat",
  "Senzație de frig permanent": "Constant feeling of cold",
  "Senzație de sufocare": "Feeling of suffocation",
  "Sensibilitate la lumină": "Light sensitivity",
  "Sensibilitate la zgomot": "Noise sensitivity",
  "Sete excesivă": "Excessive thirst",
  "Slăbiciune musculară": "Muscle weakness",
  "Somnolență excesivă": "Excessive drowsiness",
  "Spasme musculare": "Muscle spasms",
  "Stare de anxietate": "Anxiety",
  "Stare de apatie": "Apathy",
  "Stare de confuzie": "Confusion",
  "Strănut frecvent": "Frequent sneezing",
  "Scurgeri nazale": "Runny nose",
  "Transpirații abundente": "Excessive sweating",
  "Transpirații nocturne": "Night sweats",
  "Tremurături ale mâinilor": "Hand tremors",
  "Tulburări de memorie": "Memory problems",
  "Tuse cu sânge": "Coughing up blood",
  "Tuse productivă": "Productive cough",
  "Tuse seacă": "Dry cough",
  "Țiuit în urechi": "Ringing in the ears",
  "Umflarea feței": "Facial swelling",
  "Umflarea mâinilor": "Hand swelling",
  "Umflarea picioarelor": "Leg swelling",
  "Urinare dureroasă": "Painful urination",
  "Urinări frecvente": "Frequent urination",
  "Urină cu sânge": "Blood in urine",
  "Urină tulbure sau urât mirositoare": "Cloudy or foul-smelling urine",
  "Vânătăi apărute spontan": "Spontaneous bruising",
  "Vărsături": "Vomiting",
  "Vedere dublă": "Double vision",
  "Vedere încețoșată": "Blurred vision",
  "Vertij": "Vertigo",
  "Migrenă": "Migraine",
  "Reflux": "Reflux",
  "Hemoroizi": "Hemorrhoids",
  "Sughiț persistent": "Persistent hiccups",
  "Leșin": "Fainting",
  "Stare de leșin": "Faintness",
  "Durere de dinți": "Toothache",
  "Sângerare gingii": "Bleeding gums",
  "Afte bucale": "Mouth ulcers",
  "Respirație urât mirositoare": "Bad breath",
  "Sânge în scaun": "Blood in stool",
  "Scaune negre": "Black stools",
  "Mucus în scaun": "Mucus in stool",
  "Deshidratare": "Dehydration",
  "Bufeuri": "Hot flashes",
  "Căderea părului": "Hair loss",
  "Unghii fragile": "Brittle nails",
  "Modificări ale alunițelor": "Changes in moles",
  "Vindecare lentă a rănilor": "Slow wound healing",
  "Sforăit": "Snoring",
  "Sforăit excesiv": "Excessive snoring",
  "Durere la înghițire": "Painful swallowing",
  "Senzație de nod în gât": "Lump in throat sensation",
  "Greutate în piept": "Chest tightness",
  "Bătăi neregulate ale inimii": "Irregular heartbeat",
  "Mâini și picioare reci": "Cold hands and feet",
  "Crampe menstruale": "Menstrual cramps",
  "Sângerare menstruală abundentă": "Heavy menstrual bleeding",
  "Scurgeri vaginale": "Vaginal discharge",
  "Mâncărime genitală": "Genital itching",
  "Scădere a libidoului": "Decreased libido",
  "Durere pelvină": "Pelvic pain",
  "Tremor al întregului corp": "Whole-body tremor",
  "Convulsii": "Seizures",
  "Spasme faciale": "Facial spasms",
  "Ticuri": "Tics",
  "Dificultate la vorbire": "Difficulty speaking",
  "Bâlbâială": "Stuttering",
  "Halucinații": "Hallucinations",
  "Stare de agitație": "Agitation",
  "Atacuri de panică": "Panic attacks",
  "Gânduri negative": "Negative thoughts",
  "Lipsă de energie": "Lack of energy",
  "Stare de rău general": "General malaise",
  "Frison cu febră": "Chills with fever",
  "Transpirații reci": "Cold sweats",
  "Mâncărime generalizată": "Generalized itching",
  "Urticarie": "Hives",
  "Umflarea limbii": "Tongue swelling",
  "Umflarea buzelor": "Lip swelling",
  "Dificultate la urinare": "Difficulty urinating",
  "Senzație de golire incompletă a vezicii": "Feeling of incomplete bladder emptying",
  "Nicturie": "Nocturia",
  "Edem la nivelul abdomenului": "Abdominal edema",
  "Durere de sâni": "Breast pain",
  "Sensibilitate la nivelul sânilor": "Breast tenderness",
  "Umflarea sânilor": "Breast swelling",
  "Noduli la sâni": "Breast lumps",
  "Scurgeri mamelonare": "Nipple discharge",
  "Menstruație întârziată": "Late period",
  "Menstruație neregulată": "Irregular period",
  "Absența menstruației": "Absence of menstruation",
  "Sângerare între menstruații": "Bleeding between periods",
  "Sângerare după menopauză": "Postmenopausal bleeding",
  "Menstruație dureroasă": "Painful menstruation",
  "Sindrom premenstrual": "Premenstrual syndrome",
  "Bufeuri (menopauză)": "Hot flashes (menopause)",
  "Uscăciune vaginală": "Vaginal dryness",
  "Durere în timpul actului sexual": "Pain during intercourse",
  "Senzație de arsură vaginală": "Vaginal burning sensation",
  "Miros vaginal neplăcut": "Unpleasant vaginal odor",
  "Balonare premenstruală": "Premenstrual bloating",
  "Schimbări de dispoziție premenstruale": "Premenstrual mood changes",
  "Pofte alimentare premenstruale": "Premenstrual food cravings",
  "Retenție de apă": "Water retention",
  // ── Simptome ciclu (nume) ──
  "Crampe": "Cramps",
  "Crampe severe": "Severe cramps",
  "Dureri pelviene": "Pelvic pain",
  "Dureri de picioare": "Leg pain",
  "Dureri de cap": "Headache",
  "Dureri ovariene": "Ovarian pain",
  "Dureri de sâni": "Breast pain",
  "Sâni sensibili": "Tender breasts",
  "Sâni umflați": "Swollen breasts",
  "Crampe abdominale": "Abdominal cramps",
  "Gaze": "Gas",
  "Oboseală": "Fatigue",
  "Epuizare": "Exhaustion",
  "Somnolență": "Drowsiness",
  "Amețeli": "Dizziness",
  "Iritabilitate": "Irritability",
  "Anxietate": "Anxiety",
  "Tristețe": "Sadness",
  "Schimbări de dispoziție": "Mood swings",
  "Plâns ușor": "Easy crying",
  "Nervozitate": "Nervousness",
  "Lipsă de concentrare": "Lack of concentration",
  "Sensibilitate emoțională": "Emotional sensitivity",
  "Poftă de dulce": "Sweet cravings",
  "Poftă de sărat": "Salty cravings",
  "Poftă de mâncare": "Increased appetite",
  "Lipsa poftei de mâncare": "Loss of appetite",
  "Acnee": "Acne",
  "Piele grasă": "Oily skin",
  "Erupții cutanate": "Skin rashes",
  "Flux abundent": "Heavy flow",
  "Flux moderat": "Moderate flow",
  "Flux redus": "Light flow",
  "Spotting (pătare)": "Spotting",
  "Cheaguri": "Clots",
  "Scurgeri albe": "White discharge",
  "Scurgeri transparente": "Clear discharge",
  "Scurgeri lăptoase": "Milky discharge",
  "Scurgeri ca albușul de ou": "Egg-white discharge",
  "Scurgeri lipicioase": "Sticky discharge",
  "Scurgeri maronii": "Brown discharge",
  "Scurgeri roz": "Pink discharge",
  "Scurgeri abundente": "Heavy discharge",
  "Scurgeri reduse": "Light discharge",
  "Libido crescut": "Increased libido",
  "Libido scăzut": "Decreased libido",
  "Sensibilitate la mirosuri": "Sensitivity to smells",
  "Mâncărimi": "Itching",
  "Mâncărime vaginală": "Vaginal itching",
  "Sângerare intermenstruală": "Intermenstrual bleeding",
  "Link invitație": "Invitation link",
  "Relație de familie detectată": "Family relationship detected",
  "Ieși fără să salvezi? Modificările vor fi pierdute.": "Leave without saving? Your changes will be lost.",
  "Ieși": "Leave",
  "Rămâi": "Stay",

  // Formular medicament & măsurători
  "Creează profil": "Create profile",
  "La nevoie": "As needed",
  "Niciun medicament activ în plan.": "No active medication in the plan.",
  "Data": "Date",
  "Ora administrare": "Time taken",
  "Cantitate": "Quantity",
  "DCI (substanță activă)": "Active ingredient",
  "Formă farmaceutică": "Form",
  "Data începerii": "Start date",
  "Indicație / De ce se ia": "Indication / Why it's taken",
  "Stoc inițial (buc.)": "Initial stock (units)",
  "Alertă la (buc.)": "Alert at (units)",
  "Program administrare": "Dosing schedule",
  "O dată la (ore)": "Every (hours)",
  "Prima doză la": "First dose at",
  "O dată la (zile)": "Every (days)",
  "O dată la (luni)": "Every (months)",
  "Zile active": "Active days",
  "Zile de administrare": "Days on",
  "Zile pauză": "Days off",
  "Sistolică (mmHg)": "Systolic (mmHg)",
  "Diastolică (mmHg)": "Diastolic (mmHg)",
  "Glicemie": "Blood sugar",
  "Greutate (kg)": "Weight (kg)",
  "Saturație O₂ (%)": "O₂ saturation (%)",
  "Puls (bpm)": "Pulse (bpm)",

  // Confirmări
  "Ești sigur că vrei să ștergi? Această acțiune nu poate fi anulată.": "Are you sure you want to delete this? This action can't be undone.",

  // Mesaje / alerte
  "A apărut o eroare la restaurare: ": "An error occurred during restore: ",
  "Cel puțin două dintre studiile selectate nu au conținut extras. Reextrage-le din tab-ul Documente și încearcă din nou.": "At least two of the selected studies have no extracted content. Re-extract them from the Documents tab and try again.",
  "Comparația a eșuat: ": "Comparison failed: ",
  "Completează denumirea, valoarea și data.": "Fill in the name, value and date.",
  "Contul și toate datele au fost șterse.": "Your account and all data have been deleted.",
  "Data de început e după data de sfârșit.": "The start date is after the end date.",
  "Data introdusă nu e validă. Folosesc data documentului.": "The date entered isn't valid. Using the document date.",
  "Deblochează pop-up-urile pentru a exporta PDF.": "Allow pop-ups to export the PDF.",
  "Dispozitivul nu suportă notificări web.": "This device doesn't support web notifications.",
  "Eroare la generarea sumarului: ": "Error generating the summary: ",
  "Eroare la ștergere: ": "Error while deleting: ",
  "Eroare: ": "Error: ",
  "Extragerea AI a eșuat.\n\nMotiv: ": "AI extraction failed.\n\nReason: ",
  "Fișier invalid — nu este un backup JSON valid.": "Invalid file — not a valid JSON backup.",
  "Fișier invalid.": "Invalid file.",
  "Fișierul nu pare un backup Fișă Medicală. Continui totuși?": "This doesn't look like a Fișă Medicală backup. Continue anyway?",
  "Generarea sumarului AI a eșuat.\n\nMotiv: ": "AI summary generation failed.\n\nReason: ",
  "Generarea sumarului a eșuat.\n\nMotiv: ": "Summary generation failed.\n\nReason: ",
  "Generarea sumarului anual a eșuat.\n\nMotiv: ": "Annual summary generation failed.\n\nReason: ",
  "Link copiat!": "Link copied!",
  "Nu am putut genera fișierul de backup. Reîncearcă.": "Couldn't generate the backup file. Try again.",
  "Nu există grafice de exportat. Comută pe vizualizarea Grafic.": "No charts to export. Switch to the Chart view.",
  "Nu există un sumar generat de exportat.": "There's no generated summary to export.",
  "Nu pot extrage date din acest fișier Word (.doc/.docx).\n\nFișierele Word nu pot fi citite direct.\n\nSoluție: salvează ca PDF sau copiază conținutul într-un fișier .txt.": "Can't extract data from this Word file (.doc/.docx).\n\nWord files can't be read directly.\n\nTip: save it as PDF or copy the content into a .txt file.",
  "Nu s-a putut trimite: ": "Couldn't send: ",
  "Nu s-au găsit valori de laborator în acest document.\n\nDacă documentul conține analize, verifică calitatea scanării sau încearcă din nou.": "No lab values were found in this document.\n\nIf it contains lab results, check the scan quality or try again.",
  "Permite ferestrele pop-up pentru a genera raportul.": "Allow pop-ups to generate the report.",
  "Profilul nu a putut fi șters. Reîncearcă.": "The profile couldn't be deleted. Try again.",
  "Programarea nu are dată.": "The appointment has no date.",
  "Restaurare completă. Reîncarc aplicația pentru a afișa datele.": "Restore complete. Reloading the app to show your data.",
  "Restaurez datele din backup în profilul curent?\n\nSe adaugă peste ce există acum — recomandat pe un profil gol. Datele personale (nume, adresă, diagnostice) vor fi suprascrise.": "Restore data from the backup into the current profile?\n\nIt's added on top of what's already here — best on an empty profile. Personal details (name, address, diagnoses) will be overwritten.",
  "Scrie câteva cuvinte înainte de a trimite.": "Write a few words before sending.",
  "Selectează cel puțin două studii.": "Select at least two studies.",
  "Selectează sau scrie un vaccin": "Select or type a vaccine",
  "Text copiat pentru partajare!": "Text copied for sharing!",
  "Închizi fără să salvezi? Modificările vor fi pierdute.": "Close without saving? Your changes will be lost.",
  "Ștergi această valoare din istoric?": "Delete this value from the history?",
  "Ștergi această înregistrare?": "Delete this record?",
  "Ștergi acest vaccin?": "Delete this vaccine?",
  "Ștergi toate valorile extrase din acest document?": "Delete all values extracted from this document?",

  // Feedback
  "Sugestie": "Suggestion",
  "O idee de îmbunătățire": "An idea for improvement",
  "Problemă": "Problem",
  "Ceva nu funcționează": "Something isn't working",
  "Design": "Design",
  "Aspect / ușurință în utilizare": "Look / ease of use",
  "Apreciere": "Appreciation",
  "Ceva ce îți place": "Something you like",
  "Altceva": "Something else",
  "Orice alt gând": "Any other thought",
  "Părerea ta contează! Spune-ne ce ți-a plăcut, ce te-a încurcat sau ce ai vrea să adăugăm. Fiecare mesaj ajunge direct la echipa care dezvoltă aplicația.": "Your opinion matters! Tell us what you liked, what confused you or what you'd like us to add. Every message goes straight to the team building the app.",
  "Mulțumim! Feedback-ul tău a fost trimis.": "Thank you! Your feedback has been sent.",
  "Ce fel de feedback?": "What kind of feedback?",
  "Cât de mulțumit ești de aplicație? (opțional)": "How satisfied are you with the app? (optional)",
  "Mesajul tău": "Your message",
  "Scrie aici gândurile tale...": "Write your thoughts here...",
  "Se trimite...": "Sending...",
  "Trimite feedback": "Send feedback",
  "Feedback-ul include adresa ta de email (pentru a te putea contacta).": "Feedback includes your email address (so we can contact you).",

  // Diverse
  "Se încarcă datele...": "Loading your data...",
  "Ce vrei să faci?": "What do you want to do?",
  "Nu, mulțumesc": "No, thanks",
  "Vaccin": "Vaccine",
  "ex: Vaccin specific": "e.g. specific vaccine",
  "ex: doza 1, rapel": "e.g. dose 1, booster",
  "ex: lot, reacții, medic": "e.g. batch, reactions, doctor",
  "Adăugare": "Add",
  "Medicament": "Medication",
  "Inactive": "Inactive",

  // Batch 2 — restul interfeței
  "Acces limitat · AI poate accesa istoricul familial pentru recomandări": "Limited access · AI can use family history for recommendations",
  "Această acțiune este definitivă": "This action is permanent",
  "Această persoană are acces complet la dosar — poate introduce și edita date. Se loghează cu contul ei (necesită email).": "This person has full access to the record — they can enter and edit data. They log in with their own account (email required).",
  "Acest sumar este generat automat de inteligență artificială și are rol orientativ. Nu înlocuiește consultul, diagnosticul sau interpretarea unui medic.": "This summary is generated automatically by AI and is for guidance only. It doesn't replace a doctor's consultation, diagnosis or interpretation.",
  "Adaugă date medicale pentru a genera sumarul.": "Add medical data to generate the summary.",
  "Agravări": "Worsening",
  "Alege din listă — redenumirea la o analiză existentă îi alătură valorile la istoric.": "Pick from the list — renaming to an existing test merges its values into the history.",
  "Alertă înainte cu": "Alert before",
  "Am citit și accept ": "I have read and accept ",
  "Ameliorări": "Improvements",
  "Analize medicale": "Lab results",
  "Analize → Dispozitive": "Lab results → Devices",
  "Analiză": "Test",
  "Bifează studiile de comparat (minim 2). Pot fi de tipuri diferite (CT, PET-CT, RMN) — comparația se face cronologic, de la cel mai vechi la cel mai recent.": "Check the studies to compare (at least 2). They can be of different types (CT, PET-CT, MRI) — the comparison is chronological, from oldest to newest.",
  "Bine ai venit!": "Welcome!",
  "Caută denumirea...": "Search the name...",
  "Caută medicament...": "Search medication...",
  "Caută sau scrie denumirea...": "Search or type the name...",
  "Caută sau scrie un simptom...": "Search or type a symptom...",
  "Caută specializare...": "Search specialty...",
  "Completează datele tale pentru a începe. Toate câmpurile sunt obligatorii.": "Fill in your details to get started. All fields are required.",
  "Condiții medicale cunoscute": "Known medical conditions",
  "Confirmă parola nouă": "Confirm new password",
  "Creează un dosar medical complet și separat pentru această persoană.": "Create a complete, separate medical record for this person.",
  "Data analizei": "Test date",
  "Data nașterii *": "Date of birth *",
  "Denumire analiză": "Test name",
  "Denumire comercială ": "Brand name ",
  "Doar erori": "Errors only",
  "Durată menstruație: ": "Period duration: ",
  "Evoluție analize — grafice": "Lab trends — charts",
  "Fază luteală: ": "Luteal phase: ",
  "Fereastră fertilă: ": "Fertile window: ",
  "Fișă Medicală · versiune web": "Fișă Medicală · web version",
  "Grad de rudenie...": "Relationship...",
  "Grafice analize": "Lab charts",
  "Ieși din cont": "Sign out",
  "Include datele acestui profil (fără fișierele documentelor încărcate — doar denumirile și sumarele lor).": "Includes this profile's data (without the uploaded document files — only their names and summaries).",
  "Intensitate, durată, context...": "Intensity, duration, context...",
  "Lungime ciclu: ": "Cycle length: ",
  "Maxim referință": "Reference max",
  "Menstruații înregistrate: ": "Periods logged: ",
  "Minim referință": "Reference min",
  "Modifică valorile extrase din document.": "Edit the values extracted from the document.",
  "Necesită email": "Email required",
  "Nicio activitate înregistrată în această perioadă.": "No activity logged in this period.",
  "Niciun log încă. Folosește aplicația (ex. încarcă un fișier) și revino aici.": "No logs yet. Use the app (e.g. upload a file) and come back here.",
  "Notă suplimentară": "Additional note",
  "Notă...": "Note...",
  "Nume complet *": "Full name *",
  "Observații, recomandări...": "Observations, recommendations...",
  "Ora": "Time",
  "Ovulație estimată: ": "Estimated ovulation: ",
  "Parola actuală": "Current password",
  "Partajare acces": "Share access",
  "Persoană de contact în urgență *": "Emergency contact *",
  "Politica de confidențialitate (GDPR)": "Privacy Policy (GDPR)",
  "Politica de cookie-uri": "Cookie Policy",
  "Prenume Nume": "First Last",
  "Privire generală": "Overview",
  "Recomandare": "Recommendation",
  "Recomandări": "Recommendations",
  "Relație": "Relationship",
  "Repetă parola": "Repeat password",
  "Restaurează datele dintr-un fișier salvat anterior. Recomandat pe un profil gol.": "Restore data from a previously saved file. Best on an empty profile.",
  "Scrie notiță...": "Write a note...",
  "Scrie o notiță pentru această zi...": "Write a note for this day...",
  "Setări → Aplicații de sănătate": "Settings → Health apps",
  "Sex ": "Sex ",
  "Sex *": "Sex *",
  "Spital": "Hospital",
  "Stabil": "Stable",
  "Status": "Status",
  "Telefon *": "Phone *",
  "Telefon personal *": "Personal phone *",
  "Temperatură (°C)": "Temperature (°C)",
  "Tendințe": "Trends",
  "Termenii și condițiile": "the Terms & Conditions",
  "Toate": "All",
  "Trage în sus sau în jos · ridică degetul pentru a fixa": "Drag up or down · lift your finger to set",
  "Trimite link pe email — persoana poate vedea propriul profil. AI-ul are acces la istoricul familial pentru recomandări personalizate.": "Send a link by email — the person can see their own profile. The AI can use family history for personalized recommendations.",
  "Un fișier de backup (JSON) cu profilul, analizele, tratamentul, vaccinurile etc.": "A backup file (JSON) with the profile, lab results, treatment, vaccines, etc.",
  "Unitate": "Unit",
  "Valoare": "Value",
  "Valori de urmărit": "Values to watch",
  "Valorile sunt extrase automat de AI și pot conține erori. Verifică-le cu documentul original. Nu înlocuiesc interpretarea unui medic.": "Values are extracted automatically by AI and may contain errors. Check them against the original document. They don't replace a doctor's interpretation.",
  "Verificare în 2 pași": "Two-step verification",
  "se completează automat": "filled in automatically",
  "toate": "all",
  "nu pot fi recuperate": "can't be recovered",
  "Șterge definitiv contul tău și ": "Permanently delete your account and ",
  "Șterge doar acest profil și datele lui. Contul tău rămâne. Pentru a gestiona contul, treci pe profilul tău.": "Deletes only this profile and its data. Your account remains. To manage your account, switch to your profile.",
  "Țară *": "Country *",
  "Ți-am trimis un cod de 6 cifre pe ": "We sent a 6-digit code to ",
  "— Selectează —": "— Select —",
  "ZZ.LL.AAAA": "DD.MM.YYYY",
  "adresa@email.com": "you@email.com",
  "medic@email.com": "doctor@email.com",
  "menstruație": "period",
  "fertilă": "fertile",
  "Dr. Prenume Nume": "Dr. First Last",
  "ex: România": "e.g. Romania",
  "ex: Cristina Hașaș": "e.g. Jane Doe",
  "ex: Gheorghe Ionescu": "e.g. John Doe",
  "ex: Metformin, Amlodipină...": "e.g. Metformin, Amlodipine...",
  "ex: Fibrilație atrială": "e.g. Atrial fibrillation",
  "ex: Diabet, Cancer, Hipertensiune...": "e.g. Diabetes, Cancer, Hypertension...",
  "ex: Control tensiune arterială, diabet...": "e.g. Blood-pressure check, diabetes...",
  "ex: Control la 6 luni": "e.g. Check-up in 6 months",
  "ex: 5.2": "e.g. 5.2", "ex: g/dL": "e.g. g/dL", "ex: mmol/L": "e.g. mmol/L",
  "ex: 3.9": "e.g. 3.9", "ex: 6.1": "e.g. 6.1", "ex: 900041": "e.g. 900041",
  "ex: 30": "e.g. 30", "ex: 5": "e.g. 5", "ex: 21": "e.g. 21", "ex: 7": "e.g. 7",
  "ex: 130": "e.g. 130", "ex: 80": "e.g. 80", "ex: 82": "e.g. 82", "ex: 98": "e.g. 98",
  "ex: 72": "e.g. 72", "ex: 36.6": "e.g. 36.6",

  "Acces partajat": "Shared access",

  // Butoane cu iconițe & etichete compuse
  " profilurile din el. Ireversibil.": " profiles in it. Irreversible.",
  " Șterge": " Delete",
  " Șterge simptom": " Delete symptom",
  " Șterge tot": " Delete all",
  "(caută în nomenclatorul ANMDMR)": "(searches the ANMDMR registry)",
  "(se completează automat din rudenie, poate fi modificat)": "(filled in automatically from the relationship, editable)",
  "+ Adaugă": "+ Add",
  "+ Adaugă analiză manual": "+ Add result manually",
  "+ Adaugă doză": "+ Add dose",
  "+ Adaugă telefon": "+ Add phone",
  "+ Adaugă valoare": "+ Add value",
  "+ Adăugare": "+ Add",
  ". Am înțeles că aplicația nu oferă sfaturi medicale.": ". I understand the app doesn't provide medical advice.",
  ". Introdu-l mai jos.": ". Enter it below.",
  "← Ieși din cont": "← Sign out",
  "← Schimbă": "← Change",
  "← Înapoi": "← Back",
  "← Înapoi în aplicație": "← Back to the app",
  "↑ Îmbunătățiri față de perioada precedentă": "↑ Improvements vs. previous period",
  "↕ Schimbări față de perioada precedentă": "↕ Changes vs. previous period",
  "↗ Trimite": "↗ Send",
  "↩ Înapoi": "↩ Back",
  "↻ Reîmprospătează": "↻ Refresh",
  "↻ Încearcă din nou": "↻ Try again",
  "⏳ Procesez...": "⏳ Processing...",
  "⚠ Aspecte": "⚠ Aspects",
  "⚠ Aspecte de urmărit": "⚠ Aspects to watch",
  "⚠ Persoane de urgență *": "⚠ Emergency contacts *",
  "⚠ Îngrijorări": "⚠ Concerns",
  "⚠️ Comparație generată de AI — nu înlocuiește interpretarea medicului radiolog.": "⚠️ Comparison generated by AI — doesn't replace the radiologist's interpretation.",
  "✎ Editează": "✎ Edit",
  "✓ Acces partajat": "✓ Shared access",
  "✓ Confirmat": "✓ Confirmed",
  "✓ Recomandări": "✓ Recommendations",
  "✓ Salvează modificările": "✓ Save changes",
  "✓ Îmbunătățiri": "✓ Improvements",
  "✕ Anulează": "✕ Cancel",
  "✦ Generează acum": "✦ Generate now",
  "✦ Recomandări AI — risc familial": "✦ AI recommendations — family risk",
  "⬆ Încarcă": "⬆ Upload",
  "⬇ Descarcă": "⬇ Download",
  "🏥 Evoluție diagnostice": "🏥 Diagnosis history",
  "👩‍⚕️ Îngrijitor": "👩‍⚕️ Caregiver",
  "💊 Notițe medicamente": "💊 Medication notes",
  "💊 Respectarea tratamentului": "💊 Treatment adherence",
  "💊 Schimbări tratament": "💊 Treatment changes",
  "💕 Contact intim": "💕 Intimacy",
  "📅 Adaugă în calendarul telefonului": "📅 Add to phone calendar",
  "📆 Generează acum": "📆 Generate now",
  "📊 Calculat din datele tale": "📊 Calculated from your data",
  "📊 Evoluție valori": "📊 Value trends",
  "📊 Statistică activitate": "📊 Activity stats",
  "📊 Valori": "📊 Values",
  "📋 Copiază link": "📋 Copy link",
  "📋 Copiază tot": "📋 Copy all",
  "📋 Creează profil medical": "📋 Create medical profile",
  "📋 Vezi dosar →": "📋 View record →",
  "📋 Vizualizare dosar →": "📋 View record →",
  "📌 Evenimente cheie": "📌 Key events",
  "📝 Notiță": "📝 Note",
  "📤 Partajare date cu medicul": "📤 Share data with the doctor",
  "📥 Export": "📥 Export",
  "🔄 De câte ori": "🔄 How many times",
  "🔄 Înlocuiește": "🔄 Replace",
  "🔊 Testează": "🔊 Test",
  "🔔 Notificare de terminare stoc": "🔔 Low-stock notification",
  "🤒 Simptome": "🤒 Symptoms",
  "Niciun vaccin înregistrat. Apasă „+ Vaccin\" pentru a adăuga.": "No vaccine recorded. Tap „+ Vaccine\" to add one.",
  "Vaccin nou": "New vaccine",
  "Editează vaccin": "Edit vaccine",
  "Adaugă vaccin": "Add vaccine",
  "Conectează o aplicație de sănătate din": "Connect a health app from",
  "Valorile importate vor apărea aici.": "Imported values will appear here.",

  // Rudenie
  "Soț": "Husband", "Soție": "Wife", "Fiu": "Son", "Fiică": "Daughter",
  "Mamă": "Mother", "Tată": "Father", "Bunic": "Grandfather", "Bunică": "Grandmother",
  "Frate": "Brother", "Soră": "Sister", "Unchi": "Uncle", "Mătușă": "Aunt",
  "Nepot": "Nephew", "Nepoată": "Niece", "Văr": "Cousin", "Vară": "Cousin (f)", "Altul": "Other",

  // Forme farmaceutice
  "Comprimată": "Tablet", "Comprimată filmat": "Film-coated tablet",
  "Comprimată efervescentă": "Effervescent tablet", "Comprimată sublinguală": "Sublingual tablet",
  "Capsulă": "Capsule", "Capsulă cu eliberare prelungită": "Extended-release capsule",
  "Fiolă": "Ampoule", "Perfuzie": "Infusion", "Soluție injectabilă": "Injectable solution",
  "Picături orale": "Oral drops", "Picături oftalmice": "Eye drops", "Picături auriculare": "Ear drops",
  "Spray nazal": "Nasal spray", "Spray bucal": "Oral spray", "Spray cutanat": "Skin spray",
  "Plasture": "Patch", "Supozitor": "Suppository", "Sirop": "Syrup", "Suspensie orală": "Oral suspension",
  "Granule": "Granules", "Pulbere": "Powder", "Cremă": "Cream", "Unguent": "Ointment",
  "Gel": "Gel", "Spumă": "Foam", "Ovul": "Pessary", "Inhaler": "Inhaler", "Nebulizator": "Nebulizer",
  "Alta": "Other",

  // Specialități
  "Alergologie": "Allergology", "Anestezie terapie durere": "Anesthesia & pain therapy",
  "Boli infecțioase": "Infectious diseases", "Cardiologie": "Cardiology",
  "Chirurgie cardiovasculară": "Cardiovascular surgery", "Chirurgie generală": "General surgery",
  "Chirurgie orală și maxilo-facială": "Oral & maxillofacial surgery", "Chirurgie pediatrică": "Pediatric surgery",
  "Chirurgie plastică": "Plastic surgery", "Chirurgie toracică": "Thoracic surgery",
  "Chirurgie vasculară": "Vascular surgery", "Dermatologie": "Dermatology",
  "Diabet zaharat și boli de nutriție": "Diabetes & nutrition", "Endocrinologie": "Endocrinology",
  "Gastroenterologie": "Gastroenterology", "Genetică medicală": "Medical genetics",
  "Geriatrie": "Geriatrics", "Ginecologie": "Gynecology", "Hematologie": "Hematology",
  "Imunologie clinică": "Clinical immunology", "Medicină de familie": "Family medicine",
  "Medicină generală": "General medicine", "Medicină internă": "Internal medicine",
  "Medicină sportivă": "Sports medicine", "Nefrologie": "Nephrology", "Neonatologie": "Neonatology",
  "Neurochirurgie": "Neurosurgery", "Neurologie": "Neurology", "Nutriție și dietetică": "Nutrition & dietetics",
  "Obstetrică-ginecologie": "Obstetrics & gynecology", "Oftalmologie": "Ophthalmology",
  "Oncologie": "Oncology", "Ortodonție": "Orthodontics", "Ortopedie": "Orthopedics", "ORL": "ENT",
  "Paliație": "Palliative care", "Pediatrie": "Pediatrics", "Pneumologie": "Pulmonology",
  "Psihiatrie": "Psychiatry", "Psihologie": "Psychology", "Radioterapie": "Radiotherapy",
  "Recuperare medicală": "Rehabilitation", "Reumatologie": "Rheumatology", "Stomatologie": "Dentistry",
  "Urologie": "Urology",

  // Reminder / sunet / status
  "Fără reminder": "No reminder", "Cu 1 oră înainte": "1 hour before", "Cu 2 ore înainte": "2 hours before",
  "Cu 3 ore înainte": "3 hours before", "Cu o zi înainte": "1 day before", "Cu 2 zile înainte": "2 days before",
  "Cu o săptămână înainte": "1 week before",
  "Implicit": "Default", "Clopoțel": "Bell", "Bip": "Beep", "Melodie blândă": "Gentle melody",
  "Bun": "Good", "Atenție": "Caution", "Îngrijorător": "Concerning", "Niciun rezultat": "No results",

  // Luni & zile
  "Ianuarie": "January", "Februarie": "February", "Martie": "March", "Aprilie": "April",
  "Mai": "May", "Iunie": "June", "Iulie": "July", "August": "August", "Septembrie": "September",
  "Octombrie": "October", "Noiembrie": "November", "Decembrie": "December",

  // Comune
  "Editează": "Edit",
  "Șterge": "Delete",
  "Adaugă": "Add",
  "Închide": "Close",
  "Da": "Yes",
  "Nu": "No",
};
